import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    CommandDialogDynamicStyleType
} from "../../type";

const stylesheet = StyleSheet.create({
    gutter: {
        pointerEvents: "box-none",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 1
    },
    sheet: {
        alignSelf: "stretch",
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    windowHeight,
    colors,
    insets,
    spaces
}: CommandDialogDynamicStyleType) => {
    const styles = {
        gutter: {
            paddingTop: windowHeight * shapeConfigs.commandTopRatio,
            paddingHorizontal: spaces.spacingLg,
            paddingBottom: spaces.spacingLg
        } as Mutable<ViewStyle>,
        sheet: {
            backgroundColor: colors.content.container.default,
            paddingBottom: insets.bottom,
            paddingTop: insets.top
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
